/* import __COLOCATED_TEMPLATE__ from './circle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();